export default "__VITE_ASSET__Bw8dJ3RP__"